export default __webpack_public_path__ + "static/dragonqueen-036d65325c7bd6140335537db27daaac.png";